import React from "react";

export const ModalDesiredCurrencyTitle = () => {
	return (
		<h3 style={{ textAlign: 'center' }}>
			Seleccionar en qué moneda ingresar el monto
		</h3>
	)
}